module.exports = __webpack_public_path__ + "static/jc04657-preparation-storage-bag-ed7dc6d48a2483d80e136487447ef41c.png";